"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getStringifiedFieldValue = void 0;
var core_1 = require("@newfront-insurance/core");
var core_money_1 = require("@newfront-insurance/core-money");
var dsl_schema_api_1 = require("@newfront-insurance/dsl-schema-api");
var string_formatters_1 = require("@newfront-insurance/string-formatters");
var find_1 = __importDefault(require("lodash/find"));
var get_1 = __importDefault(require("lodash/get"));
var registry_1 = require("../value/registry");
function getStringifiedFieldValue(
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types,@typescript-eslint/no-explicit-any
value, field) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    var returnValue = null;
    if (!field) {
        return null;
    }
    var type = field.inputType, metadata = field.inputMetadata, layout = field.layout;
    var customGetStringifiedFieldValue = (_a = registry_1.customValueComponentsRegistry[type]) === null || _a === void 0 ? void 0 : _a.getStringifiedFieldValue;
    if (customGetStringifiedFieldValue) {
        return customGetStringifiedFieldValue(value, field);
    }
    switch (type) {
        case dsl_schema_api_1.InputType.NESTED_SCHEMA:
            returnValue = (layout || [])
                .flatMap(function (group) {
                return group.inputs.flatMap(function (input) {
                    var nestedField = (field.properties || {})[input];
                    var nestedValue = (0, get_1.default)(value, input);
                    if (!nestedValue) {
                        return null;
                    }
                    return getStringifiedFieldValue(nestedValue, nestedField);
                });
            })
                .filter(Boolean)
                .join(' ');
            break;
        case dsl_schema_api_1.InputType.CHECKBOX:
            returnValue = value ? 'Yes' : 'No';
            break;
        case dsl_schema_api_1.InputType.CURRENCY:
            returnValue = typeof value !== 'undefined' ? (0, core_money_1.moneyToString)(value, { fractionDigits: 2 }) : '-';
            break;
        case dsl_schema_api_1.InputType.CURRENCY_APPLIES:
            returnValue = (0, core_money_1.moneyToString)(value === null || value === void 0 ? void 0 : value.money, { fractionDigits: 2 });
            break;
        case dsl_schema_api_1.InputType.CURRENCY_PERCENTAGE:
            if ((value === null || value === void 0 ? void 0 : value.type) === 'MONETARY')
                returnValue = (0, core_money_1.moneyToString)(value === null || value === void 0 ? void 0 : value.money, { fractionDigits: 2 });
            if ((value === null || value === void 0 ? void 0 : value.type) === 'PERCENTAGE')
                returnValue = (0, core_1.isNotNil)(value === null || value === void 0 ? void 0 : value.percentage) ? (value === null || value === void 0 ? void 0 : value.percentage) + "%" : '-';
            if ((value === null || value === void 0 ? void 0 : value.type) === 'NOT_APPLICABLE')
                returnValue = 'Not applicable';
            break;
        case dsl_schema_api_1.InputType.CURRENCY_WITH_NUMBER:
            returnValue = (0, core_money_1.moneyToString)(value === null || value === void 0 ? void 0 : value.moneyLimit, {
                fractionDigits: 2,
            }) + " " + ((_b = metadata === null || metadata === void 0 ? void 0 : metadata.numberFieldLabel) === null || _b === void 0 ? void 0 : _b.toLowerCase()) + " " + (value === null || value === void 0 ? void 0 : value.durationInMonthsLimit);
            if (metadata === null || metadata === void 0 ? void 0 : metadata.appendText) {
                returnValue += " " + (metadata === null || metadata === void 0 ? void 0 : metadata.appendText);
            }
            break;
        case dsl_schema_api_1.InputType.CURRENCY_WITH_TYPE: {
            var option = (0, find_1.default)(metadata === null || metadata === void 0 ? void 0 : metadata.options, { value: value === null || value === void 0 ? void 0 : value.type });
            returnValue = (value === null || value === void 0 ? void 0 : value.money)
                ? (0, core_money_1.moneyToString)(value === null || value === void 0 ? void 0 : value.money, { fractionDigits: 2 }) + " " + (option === null || option === void 0 ? void 0 : option.label.toLowerCase())
                : (_c = option === null || option === void 0 ? void 0 : option.label) !== null && _c !== void 0 ? _c : '';
            break;
        }
        case dsl_schema_api_1.InputType.DATE:
            returnValue = (0, core_1.isNotNil)(value) ? (0, string_formatters_1.standardUTCDateFormat)(value) : null;
            break;
        case dsl_schema_api_1.InputType.PERCENTAGE:
            returnValue = (0, core_1.isNotNil)(value) ? String(value) + "%" : '-';
            break;
        case dsl_schema_api_1.InputType.RADIO: {
            var option = (0, find_1.default)(metadata === null || metadata === void 0 ? void 0 : metadata.options, { value: value });
            returnValue = (_d = option === null || option === void 0 ? void 0 : option.label) !== null && _d !== void 0 ? _d : '';
            break;
        }
        case dsl_schema_api_1.InputType.MULTI_SELECT: {
            returnValue = (_e = value) === null || _e === void 0 ? void 0 : _e.map(function (v) { var _a, _b; return (_b = (_a = metadata === null || metadata === void 0 ? void 0 : metadata.options) === null || _a === void 0 ? void 0 : _a.find(function (o) { return o.value === v; })) === null || _b === void 0 ? void 0 : _b.label; }).join(', ');
            break;
        }
        case dsl_schema_api_1.InputType.SELECT: {
            var option = (0, find_1.default)(metadata === null || metadata === void 0 ? void 0 : metadata.options, { value: value });
            returnValue = (_f = option === null || option === void 0 ? void 0 : option.label) !== null && _f !== void 0 ? _f : value;
            break;
        }
        case dsl_schema_api_1.InputType.NUMBER:
            if (value !== null && value !== undefined) {
                returnValue = (metadata === null || metadata === void 0 ? void 0 : metadata.skipFormat) ? value : new Intl.NumberFormat('en-US').format(value);
                if (metadata === null || metadata === void 0 ? void 0 : metadata.appendText) {
                    returnValue += " " + (metadata === null || metadata === void 0 ? void 0 : metadata.appendText);
                }
            }
            break;
        case dsl_schema_api_1.InputType.ADDRESS:
            returnValue = value === null || value === void 0 ? void 0 : value.formattedAddress;
            break;
        case dsl_schema_api_1.InputType.ADDRESS_OR_STATE:
            if ((_g = value === null || value === void 0 ? void 0 : value.address) === null || _g === void 0 ? void 0 : _g.formattedAddress) {
                returnValue = value.address.formattedAddress;
            }
            if (value === null || value === void 0 ? void 0 : value.state) {
                var option = (0, find_1.default)((_j = (_h = field.properties) === null || _h === void 0 ? void 0 : _h.state.inputMetadata) === null || _j === void 0 ? void 0 : _j.options, { value: value.state });
                returnValue = (_k = option === null || option === void 0 ? void 0 : option.label) !== null && _k !== void 0 ? _k : value.state;
            }
            break;
        case dsl_schema_api_1.InputType.TEXT:
        default:
            if (value !== null && value !== undefined) {
                returnValue = String(value);
            }
            break;
    }
    return returnValue;
}
exports.getStringifiedFieldValue = getStringifiedFieldValue;
